const validator = require('validator')
const has = require('lodash/has')
const CPF = require('gerador-validador-cpf')

export default (values, isEditing = false) => {
  let errors = {}

  if (!values.firstName) {
    errors.firstName = 'Forneça um nome'
  }

  if (!values.lastName) {
    errors.lastName = 'Forneça um sobrenome'
  }

  if (values.cpf) {
    if (!CPF.validate(values.cpf)) {
      errors.cpf = 'Forneça um número de CPF válido!'
    }
  }

  if (values.docNum) {
    if (values.docNum.length < 3) {
      errors.docNum = 'Forneça um Documento de Identificação!'
    }
  }

  if (!values.cpf && !values.docNum) {
    errors.cpf = 'Forneça um número de CPF ou Documento de Identificação!'
    errors.docNum = 'Forneça um número de CPF ou Documento de Identificação!'
  }

  if (values.email) {
    if (!validator.isEmail(values.email)) {
      errors.email = 'Forneça um endereço de correio eletrônico válido!'
    }
  } else {
    errors.email = 'Forneça um endereço de correio eletrônico!'
  }

  if (!isEditing) {
    if (values.password) {
      if (
        !validator.matches(
          values.password,
          /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
        )
      ) {
        errors.password =
          'A senha deve conter mais de 8 caracteres entre letras e números!'
      }
    } else {
      errors.password = 'Forneça uma senha!'
    }
  }

  if (values.profileType) {
    if (values.profileType === 'OUTSOURCED') {
      if (!has(values.profileData, 'contract')) {
        errors.profileData = { contract: 'Forneça o número do contrato!' }
      }

      if (
        has(values.profileData, 'contract') &&
        validator.isEmpty(values.profileData.contract)
      ) {
        errors.profileData = { contract: 'Forneça o número do contrato!' }
      }
    }

    if (values.profileType === 'EVENT_PARTICIPENT') {
      if (!has(values.profileData, 'eventName')) {
        errors.profileData = { eventName: 'Forneça o nome do evento!' }
      }

      if (
        has(values.profileData, 'eventName') &&
        validator.isEmpty(values.profileData.eventName)
      ) {
        errors.profileData = { eventName: 'Forneça o nome do evento!' }
      }
    }
  }

  return errors
}
